import { useEffect, useState } from 'react';
import { cookieService } from '@/services/cookie.service';
import { StoredCookies } from '@/interfaces/auth/cookies.enum';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const accessToken = cookieService.getCookie(StoredCookies.ACCESS_TOKEN);
      setIsAuthenticated(!!accessToken);
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  return {
    isAuthenticated,
    isLoading
  };
}; 